module.exports = __webpack_public_path__ + "img/galery-palm-x6-plus-3.3b0c1a88.png";